import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PolicyLayout({ children, title }: { children: ReactNode; title: string }) {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    }}>
      {/* Header */}
      <header style={{
        background: 'rgba(255,255,255,0.1)',
        backdropFilter: 'blur(10px)',
        borderBottom: '1px solid rgba(255,255,255,0.2)',
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '20px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
          <div 
            onClick={() => navigate('/')}
            style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '10px',
              cursor: 'pointer',
            }}
          >
            <span style={{ fontSize: '28px' }}>🖊️</span>
            <h1 style={{ color: 'white', margin: 0, fontSize: '24px' }}>VirtueSign</h1>
          </div>
          <button
            onClick={() => navigate('/')}
            style={{
              background: 'rgba(255,255,255,0.2)',
              color: 'white',
              padding: '10px 20px',
              border: '1px solid rgba(255,255,255,0.3)',
              borderRadius: '6px',
              cursor: 'pointer',
              fontWeight: '500',
              backdropFilter: 'blur(10px)',
            }}
          >
            ← Back to Home
          </button>
        </div>
      </header>

      {/* Content */}
      <main style={{
        maxWidth: '900px',
        margin: '40px auto',
        padding: '20px',
      }}>
        <div style={{
          background: 'white',
          borderRadius: '16px',
          padding: '60px',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        }}>
          <h1 style={{
            margin: '0 0 30px',
            fontSize: '42px',
            fontWeight: '700',
            color: '#1f2937',
            borderBottom: '3px solid #667eea',
            paddingBottom: '20px',
          }}>
            {title}
          </h1>
          
          <div style={{
            fontSize: '16px',
            lineHeight: '1.8',
            color: '#374151',
          }}>
            {children}
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer style={{
        maxWidth: '1200px',
        margin: '60px auto 0',
        padding: '40px 20px',
        textAlign: 'center',
        color: 'rgba(255,255,255,0.8)',
      }}>
        <p style={{ margin: '0 0 15px' }}>© {new Date().getFullYear()} VirtueSign by Virtue ApS</p>
        <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <a href="/support" style={{ color: 'white', textDecoration: 'none', opacity: 0.9 }}>Support</a>
          <a href="/privacy" style={{ color: 'white', textDecoration: 'none', opacity: 0.9 }}>Privacy Policy</a>
          <a href="/terms" style={{ color: 'white', textDecoration: 'none', opacity: 0.9 }}>Terms of Service</a>
        </div>
      </footer>
    </div>
  );
}
